<template>
  <div class="card">
    <div class="card-content">
      <div class="media">
        <div class="media-content">
          <p class="is-size-5">{{ course.job_title }}</p>
        </div>
      </div>

      <div class="content">
        <p>{{ course.job_description }}</p>

        <router-link :to="{ name: 'Course', params: { slug: course.slug } }"
          >More</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["course"],
};
</script>
